<template>
	<!-- @vue-ignore -->
	<MsAjaxTemplate
		template-name="build-edit-notification-dialog"
		:ready-dependencies="readyDependencies"
	/>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import MsAjaxTemplate from '../utils/MsAjaxTemplate';

	const readyDependencies = ['admin-component-library'];

	export default defineComponent({
		components: { MsAjaxTemplate },
		setup() {
			return { readyDependencies };
		}
	});
</script>
